import { flow } from 'lodash';
import { NAME } from './domain.constant';

import { selectState as selectStatePDV } from '../debts.selector';

const selectStateKey = (state) => state[NAME];
const selectDataKey = (state) => state.data;
const selectLoadingKey = (state) => state.loading;
const selectErrorKey = (state) => state.error;
const selectFiltersKey = (state) => state.filters;

export const selectState = flow(selectStatePDV, selectStateKey);
export const selectData = flow(selectState, selectDataKey);
export const selectLoading = flow(selectState, selectLoadingKey);
export const selectError = flow(selectState, selectErrorKey);
export const selectFilters = flow(selectState, selectFiltersKey);
